<div>
  <label *ngIf="label" class="label">{{ label }}</label>
  <div [ngClass]="['input-container', containerClassName]" [ngStyle]="{ 'max-width' : fullWidth ? '100%': '400px' }">
      <div *ngIf="icon"
           class="input-icon-container"
           [style.width.px]="iconContainerWidth">
          <svg-icon [name]="icon"
                    [size]="iconSize">
          </svg-icon>
      </div>
  
      <input [formControl]="control"
             [placeholder]="placeholder"
             [ngClass]="{'input': true, 'form-input': true, 'ant-picker': disabled, 'ant-picker-disabled': disabled}"
             [style.padding-left.px]="icon ? iconContainerWidth : 8"
             [style.padding-right.px]="isShowClearButton || isShowEditButton ? iconContainerWidth : 0"
             [readonly]="disabled"/>
  
      <div *ngIf="isShowClearButton"
           class="input-icon-container right"
           [style.width.px]="iconContainerWidth">
          <i nz-icon
             nzType="close"
             nzTheme="outline"
             (click)="clear()"></i>
      </div>
      
      <button nz-button *ngIf="isShowEditButton" nzType="text"
           class="input-icon-container right"
           [style.width.px]="iconContainerWidth"
           (click)="edit()"
           [nzPopoverTrigger]="!!this.editPopoverTemplate ? 'click' : null" nzPopoverPlacement="bottomRight" [nzPopoverContent]="this.editPopoverTemplate" nz-popover>
          <i nz-icon 
             [nzType]="editFontType"
             nzTheme="outline"
             [nzTheme]="this.editButtonColor ? 'twotone' : 'outline'" 
             [nzTwotoneColor]="this.editButtonColor"
             ></i>
             
    </button>
</div>
</div>
